// startup
// Load entry module and return exports
__webpack_require__("./node_modules/error-overlay-webpack-plugin/lib/entry-basic.js");
// This entry module is referenced by other modules so it can't be inlined
var __webpack_exports__ = __webpack_require__("./app/public/wp-content/themes/stntheme/src/scripts/main.ts");
